<ng-container *transloco="let t;">
  <div *ngIf="exercise !== null">

    <p-table [value]="exercise.elements" [reorderableColumns]="inOrdering === true" (onRowReorder)="onRowReorder($event)">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem" *ngIf="inOrdering === true"></th>
          <th style="width:50%;">{{ t('common.labels.name') }}</th>
          <th>{{ t('common.labels.type') }}</th>
          <th style="width:180px;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-element let-index="rowIndex">
        <tr [pReorderableRow]="index">
          <td *ngIf="inOrdering === true">
            <span class="pi pi-bars" pReorderableRowHandle></span>
          </td>
          <td><span role="link" (click)="onOpenElement(element)" (keyup.enter)="onOpenElement(element)" tabindex="0">{{ element.name }}</span></td>
          <td>{{ t(element.getTypename()) }}</td>
          <td style="text-align: right">
            <ng-container *ngIf="inOrdering !== true">
              <button withRight="admin.element.show" pButton (click)="onOpenElement(element)" type="button" icon="pi pi-pencil"></button>
              <button withRight="admin.element.create" pButton (click)="onDuplicateElement(element)" type="button" icon="pi pi-copy" class="p-button-outlined p-ml-2"></button>
              <button withRight="admin.element.delete" pButton (click)="onDeleteElement(element)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="!element.deletable"></button>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>

  </div>

  <app-inherit-dialog
    [title]="inheritMode === 'duplicate' ? t('common.labels.duplicate') : t('common.labels.delete')"
    [mode]="'exercise'"
    [(visible)]="inheritVisible"
    (okClicked)="executeInheritAction($event)"
  ></app-inherit-dialog>

</ng-container>
